<div class="tw-flex tw-justify-between tw-mr-2">
  <h2
    [id]="titleId"
    class="tw-pt-8 tw-m-0 tw-pl-[24px] tw-text-[16px] tw-font-semibold"
    [ngClass]="{ 'tw-flex-1 tw-text-center': centered }"
  >
    <ng-content></ng-content>
  </h2>
  <button
    type="button"
    id="closeButton"
    mat-icon-button
    class="close"
    [mat-dialog-close]="false"
    data-close="modal"
    aria-label="Click to close this modal"
  >
    <mat-icon svgIcon="close" />
  </button>
</div>
